import axios, { AxiosInstance } from "axios";

class HttpClient {
  private static instance: AxiosInstance;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {} // Prevenir instanciación directa

  static getInstance(): AxiosInstance {
    if (!HttpClient.instance) {
      HttpClient.instance = axios.create({
        baseURL: process.env.VUE_APP_API_BASE_URL || "https://api.example.com",
        timeout: 10000,
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Interceptores para agregar tokens o manejar errores
      HttpClient.instance.interceptors.request.use(
        (config) => {
          // Ejemplo: agregar un token de autorización
          const token = localStorage.getItem("auth_token");
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
          return config;
        },
        (error) => Promise.reject(error)
      );

      HttpClient.instance.interceptors.response.use(
        (response) => response,
        (error) => {
          // Manejo de errores global
          console.error("Error en la respuesta HTTP:", error);
          return Promise.reject(error);
        }
      );
    }
    return HttpClient.instance;
  }
}

export default HttpClient;
